import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

export default function Login() {
  const { verifyOTP: authVerifyOTP, sendOTP: authSendOTP } = useAuth();
  const navigate = useNavigate();

  const [step,    setStep]    = useState(1);
  const [email,   setEmail]   = useState("");
  const [otp,     setOtp]     = useState("");
  const [loading, setLoading] = useState(false);
  const [timer,   setTimer]   = useState(0);
  const [name,    setName]    = useState("");

  const startTimer = () => {
    setTimer(30);
    const iv = setInterval(() => {
      setTimer(t => { if (t <= 1) { clearInterval(iv); return 0; } return t - 1; });
    }, 1000);
  };

  const handleSendOTP = async () => {
    if (!email.trim()) return toast.error("Please enter your email address.");
    if (!/^\S+@\S+\.\S+$/.test(email)) return toast.error("Please enter a valid email address.");
    setLoading(true);
    try {
      const data = await authSendOTP(email.trim().toLowerCase());
      if (data.success) {
        setName(data.name || "");
        toast.success("OTP sent to your email!");
        setStep(2);
        startTimer();
      } else {
        toast.error(data.message || "Failed to send OTP.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Unable to connect. Check your internet.");
    }
    setLoading(false);
  };

  const handleVerifyOTP = async () => {
    if (!otp.trim() || otp.length < 6) return toast.error("Please enter the 6-digit OTP.");
    setLoading(true);
    try {
      const vendorData = await authVerifyOTP(email.trim().toLowerCase(), otp.trim());
      if (vendorData?.status === "pending")  { setLoading(false); return toast.error("Your application is under review."); }
      if (vendorData?.status === "rejected") { setLoading(false); return toast.error("Your application has been rejected. Contact support."); }
      toast.success("Welcome back!");
      navigate("/");
    } catch (err) {
      toast.error(err?.message || "Incorrect OTP. Please try again.");
      setOtp("");
    }
    setLoading(false);
  };

  const handleResend = async () => {
    if (timer > 0) return;
    setOtp("");
    await handleSendOTP();
  };

  return (
    <>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes qs-spin { to { transform: rotate(360deg); } }
        @keyframes qs-fade { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; }

        .ql-page {
          min-height: 100vh;
          display: flex;
          font-family: 'Inter', 'Segoe UI', sans-serif;
          background: #f8f7ff;
        }
        .ql-left {
          width: 45%;
          background: linear-gradient(145deg, #4c1d95 0%, #7c3aed 50%, #a855f7 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 48px;
          position: relative;
          overflow: hidden;
        }
        .ql-left::before {
          content: '';
          position: absolute;
          width: 400px; height: 400px;
          border-radius: 50%;
          background: rgba(255,255,255,0.05);
          top: -100px; right: -100px;
        }
        .ql-left::after {
          content: '';
          position: absolute;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: rgba(255,255,255,0.04);
          bottom: -80px; left: -80px;
        }
        .ql-right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 32px 24px;
        }
        .ql-mobile-header {
          display: none;
        }
        .ql-form-card {
          width: 100%;
          max-width: 420px;
          background: #fff;
          border-radius: 24px;
          padding: 40px 36px;
          box-shadow: 0 20px 60px rgba(124,58,237,0.08), 0 4px 16px rgba(0,0,0,0.04);
          animation: qs-fade 0.3s ease;
        }
        .ql-input-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
          border: 1.5px solid #e5e7eb;
          border-radius: 12px;
          padding: 13px 16px;
          background: #fafafa;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .ql-input-wrap:focus-within {
          border-color: #7c3aed;
          box-shadow: 0 0 0 3px rgba(124,58,237,0.08);
          background: #fff;
        }
        .ql-input {
          flex: 1;
          font-size: 15px;
          color: #1a1a2e;
          background: none;
          border: none;
          outline: none;
          font-family: inherit;
        }
        .ql-btn {
          width: 100%;
          padding: 14px;
          background: linear-gradient(135deg, #7c3aed, #a855f7);
          color: #fff;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 700;
          border: none;
          cursor: pointer;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: opacity 0.2s, transform 0.1s;
          font-family: inherit;
        }
        .ql-btn:active { transform: scale(0.98); }
        .ql-btn:disabled { opacity: 0.75; cursor: not-allowed; }
        .ql-ghost-btn {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 13px;
          padding: 4px 0;
          font-family: inherit;
        }
        .ql-ghost-btn:disabled { cursor: not-allowed; }

        @media (max-width: 768px) {
          .ql-page {
            flex-direction: column;
            background: linear-gradient(160deg, #4c1d95 0%, #7c3aed 40%, #f8f7ff 40%);
          }
          .ql-left { display: none; }
          .ql-right {
            flex: 1;
            padding: 0 16px 32px;
            align-items: flex-start;
            padding-top: 0;
          }
          .ql-mobile-header {
            display: block;
            padding: 48px 24px 32px;
            text-align: center;
          }
          .ql-form-card {
            padding: 28px 24px;
            border-radius: 20px;
            box-shadow: 0 8px 32px rgba(124,58,237,0.12);
            margin-top: -8px;
          }
        }

        @media (max-width: 380px) {
          .ql-form-card { padding: 24px 18px; }
        }
      `}</style>

      <div className="ql-page">
        {/* ── Left Panel (desktop only) ── */}
        <div className="ql-left">
          <div style={{ position: "relative", zIndex: 1, width: "100%", maxWidth: 360 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 56 }}>
              <div style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,0.3)" }}>
                <svg width="26" height="26" viewBox="0 0 28 28" fill="none">
                  <path d="M14 2L24 7V14C24 19.5 19.5 24.5 14 26C8.5 24.5 4 19.5 4 14V7L14 2Z" fill="white" fillOpacity="0.25"/>
                  <path d="M9 14L12.5 17.5L19 11" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span style={{ fontSize: 22, fontWeight: 800, color: "#fff", letterSpacing: "-0.5px" }}>Quickry</span>
            </div>

            <h1 style={{ fontSize: 38, fontWeight: 800, color: "#fff", lineHeight: 1.2, letterSpacing: "-1px", margin: "0 0 16px" }}>
              Your Business,<br/>Your Dashboard.
            </h1>
            <p style={{ fontSize: 15, color: "rgba(255,255,255,0.75)", lineHeight: 1.7, margin: "0 0 48px" }}>
              Manage orders, track earnings, and grow your restaurant with Quickry Vendor.
            </p>

            <div style={{ display: "flex", gap: 12, marginBottom: 40 }}>
              {[
                { num: "2,400+", label: "Orders Delivered" },
                { num: "4.8★", label: "Avg Rating" },
                { num: "₹0", label: "Commission" },
              ].map((s, i) => (
                <div key={i} style={{ flex: 1, background: "rgba(255,255,255,0.12)", borderRadius: 12, padding: "14px 12px", border: "1px solid rgba(255,255,255,0.15)", textAlign: "center" }}>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#fff", marginBottom: 4 }}>{s.num}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.65)", fontWeight: 500 }}>{s.label}</div>
                </div>
              ))}
            </div>

            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", letterSpacing: "0.5px", textTransform: "uppercase", fontWeight: 600 }}>
              Akola's Fastest Delivery Network
            </div>
          </div>
        </div>

        {/* ── Mobile Header ── */}
        <div className="ql-mobile-header">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 8 }}>
            <div style={{ width: 40, height: 40, borderRadius: 11, background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,0.3)" }}>
              <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
                <path d="M14 2L24 7V14C24 19.5 19.5 24.5 14 26C8.5 24.5 4 19.5 4 14V7L14 2Z" fill="white" fillOpacity="0.25"/>
                <path d="M9 14L12.5 17.5L19 11" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span style={{ fontSize: 22, fontWeight: 800, color: "#fff", letterSpacing: "-0.5px" }}>Quickry Vendor</span>
          </div>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>Akola's Fastest Delivery Network</p>
        </div>

        {/* ── Right Panel ── */}
        <div className="ql-right">
          <div className="ql-form-card">
            {step === 1 ? (
              <>
                <div style={{ marginBottom: 28 }}>
                  <h2 style={{ fontSize: 26, fontWeight: 800, color: "#1a1a2e", margin: "0 0 6px", letterSpacing: "-0.5px" }}>Welcome back</h2>
                  <p style={{ fontSize: 14, color: "#6b7280" }}>Sign in to your vendor account</p>
                </div>

                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 8 }}>Email address</label>
                  <div className="ql-input-wrap">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
                      <path d="M3 5h14l-7 7-7-7z" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/>
                      <path d="M3 5v10h14V5" stroke="#9ca3af" strokeWidth="1.5" strokeLinejoin="round"/>
                    </svg>
                    <input
                      className="ql-input"
                      type="email"
                      placeholder="you@restaurant.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      onKeyDown={e => e.key === "Enter" && handleSendOTP()}
                      autoComplete="email"
                    />
                  </div>
                </div>

                <button className="ql-btn" onClick={handleSendOTP} disabled={loading}>
                  {loading ? (
                    <>
                      <span style={{ display: "inline-block", width: 16, height: 16, border: "2px solid rgba(255,255,255,0.35)", borderTopColor: "#fff", borderRadius: "50%", animation: "qs-spin 0.8s linear infinite" }}/>
                      Sending OTP...
                    </>
                  ) : (
                    <>
                      Send OTP
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </>
                  )}
                </button>

                <p style={{ textAlign: "center", fontSize: 13, color: "#9ca3af" }}>
                  Need help? <span style={{ color: "#7c3aed", fontWeight: 600, cursor: "pointer" }}>Contact support</span>
                </p>
              </>
            ) : (
              <>
                <div style={{ marginBottom: 28 }}>
                  <h2 style={{ fontSize: 26, fontWeight: 800, color: "#1a1a2e", margin: "0 0 6px", letterSpacing: "-0.5px" }}>
                    {name ? `Hi, ${name.split(" ")[0]}!` : "Check your email"}
                  </h2>
                  <p style={{ fontSize: 14, color: "#6b7280", marginBottom: 10 }}>We sent a 6-digit code to</p>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#f5f3ff", color: "#7c3aed", padding: "6px 12px", borderRadius: 20, fontSize: 13, fontWeight: 600, border: "1px solid #ede9fe", maxWidth: "100%", wordBreak: "break-all" }}>
                    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
                      <path d="M3 5h14l-7 7-7-7z" stroke="#7c3aed" strokeWidth="1.5" strokeLinejoin="round"/>
                      <path d="M3 5v10h14V5" stroke="#7c3aed" strokeWidth="1.5" strokeLinejoin="round"/>
                    </svg>
                    {email}
                  </div>
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 8 }}>One-time password</label>
                  <div className="ql-input-wrap" style={{ borderColor: otp.length === 6 ? "#7c3aed" : "#e5e7eb" }}>
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
                      <rect x="4" y="9" width="12" height="8" rx="2" stroke="#9ca3af" strokeWidth="1.5"/>
                      <path d="M7 9V7a3 3 0 016 0v2" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <input
                      className="ql-input"
                      style={{ letterSpacing: "0.25em", fontSize: 22, fontWeight: 700, textAlign: "center" }}
                      type="number"
                      placeholder="000000"
                      value={otp}
                      onChange={e => setOtp(e.target.value.slice(0, 6))}
                      onKeyDown={e => e.key === "Enter" && handleVerifyOTP()}
                      maxLength={6}
                      autoFocus
                    />
                    {otp.length === 6 && (
                      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
                        <circle cx="10" cy="10" r="8" fill="#7c3aed" fillOpacity="0.15"/>
                        <path d="M6 10l3 3 5-5" stroke="#7c3aed" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </div>
                </div>

                {/* OTP dots */}
                <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 20 }}>
                  {[0,1,2,3,4,5].map(i => (
                    <div key={i} style={{
                      width: 8, height: 8, borderRadius: "50%",
                      background: i < otp.length ? "#7c3aed" : "#e5e7eb",
                      transform: i < otp.length ? "scale(1.25)" : "scale(1)",
                      transition: "all 0.15s ease",
                    }}/>
                  ))}
                </div>

                <button className="ql-btn" onClick={handleVerifyOTP} disabled={loading}>
                  {loading ? (
                    <>
                      <span style={{ display: "inline-block", width: 16, height: 16, border: "2px solid rgba(255,255,255,0.35)", borderTopColor: "#fff", borderRadius: "50%", animation: "qs-spin 0.8s linear infinite" }}/>
                      Verifying...
                    </>
                  ) : (
                    <>
                      Verify & Login
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </>
                  )}
                </button>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 12 }}>
                  <button className="ql-ghost-btn" onClick={handleResend} disabled={timer > 0 || loading}>
                    {timer > 0
                      ? <span style={{ color: "#9ca3af" }}>Resend in 00:{String(timer).padStart(2,"0")}</span>
                      : <span style={{ color: "#7c3aed", fontWeight: 600 }}>Resend OTP</span>
                    }
                  </button>
                  <span style={{ color: "#e5e7eb" }}>|</span>
                  <button className="ql-ghost-btn" onClick={() => { setStep(1); setOtp(""); }}>
                    <span style={{ color: "#6b7280" }}>Change email</span>
                  </button>
                </div>

                <p style={{ textAlign: "center", fontSize: 12, color: "#9ca3af" }}>
                  Check your inbox and spam/junk folder
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
